export const getAdelantoPostSaveState = ({
    pending,
    loading,
    error,
    success,
    contractId,
    versionId,
}) => {
    if (!pending || loading) return 'waiting';
    if (error) return 'error';
    if (!success || !contractId || !versionId) return 'waiting';
    return 'success';
};

export const dispatchContractSave = ({ type, contract, postContract, putContract }) => {
    if (!contract || Object.keys(contract).length === 0) return false;

    if (type === 'post') {
        postContract(contract);
        return true;
    }
    if (type === 'put' && contract.id) {
        putContract(contract);
        return true;
    }

    return false;
};
